export default () => {
  return {
    filter: {
      limit: 25,
      offset: 0,
    },
    compteTiers: [],
    compteTiersCount: 0,
    isLoadingCompteTiersList: false,
    errorMessage: null,
    isErrorFetch: false,

    isLoadingCompteTiersAction: false,
    success: false,
    isSuccessRefresh: false,
  }
}
